import React, { useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";
// import { animated, useSpring } from "react-spring";
import { MenuContext } from "../../contexts";
import { useAppSetting } from "../../hooks";

import Ctx from "../../contexts/welcome-modal.context";
import Cover from "../ModalCover/ModalCover";
// import welcomeImage from "../../assets/images/welcome.svg";
import auposLogo from "../../assets/images/aupos-logo.png";
// import closeButton from "../../assets/images/icons/close.svg";
import closeButton from "../../assets/images/icons/close.png";
import MealClock from "../MealClock/MealClock";

const WelcomeModal = () => {
  const theme:any = useTheme();
  const classes = useStyles(theme);
  const [state, dispatch] = useContext(Ctx.Context);
  const [menuState] = useContext(MenuContext);
  const { baseImageUrl } = menuState;
  const { expired } = useAppSetting();

  const dismiss = () => {
    dispatch({
      type: Ctx.ActionTypes.update,
      payload: {
        show: false,
        type: undefined,
        limitValue: undefined,
      },
    });
  };

  // const props = useSpring({ x: 155, from: { x: 0 } })
  return (
    <Cover dismiss={dismiss}>
      <div className={classes.closeButton} onClick={dismiss}>
        <img
          src={closeButton}
          style={{ width: "100%", height: "100%" }}
          alt=""
        />
      </div>
      <div className={classes.bannerContainer}>
        {true && (
          <img
            className={classes.shopBanner}
            src={`${baseImageUrl.replace(" ", "%20")}banner.png`}
            alt=""
          />
        )}
        {false && (
          <div className={classes.noticeContainer}>
            <div className={classes.cnNotice}>{"本包间最低消费"}</div>
            <div className={classes.enNotice}>
              {"Minimum consumption in this private room"}
            </div>
            <div className={classes.limitValue}>
              ${state.limitValue?.toFixed(2)}
            </div>
            <div className={classes.cnNotice}>{"祝您用餐愉快"}</div>
            <div className={classes.enNotice}>{"Have a good meal"}</div>
          </div>
        )}
        {/* "welcome" drawing animation */}
        {/* <img className={classes.img} src={welcomeImage} alt="" /> */}
        {/* <svg
          style={{ width: "80%", marginBottom: "18px" }}
          viewBox="0 0 70 20"
          fill="black"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="path"
            d="M6.768 18.936C5.904 18.936 5.472 18.16 5.472 16.608C5.472 16.032 5.528 15.312 5.64 14.448C5 15.728 4.36 16.76 3.72 17.544C3.096 18.328 2.456 18.72 1.8 18.72C1.288 18.72 0.856 18.48 0.504 18C0.168 17.536 0 16.968 0 16.296C0 15.704 0.12 14.976 0.36 14.112C0.616 13.232 0.912 12.472 1.248 11.832C1.6 11.176 1.888 10.848 2.112 10.848C2.24 10.848 2.416 10.896 2.64 10.992C2.88 11.088 3 11.2 3 11.328C2.664 11.84 2.312 12.6 1.944 13.608C1.576 14.6 1.392 15.448 1.392 16.152C1.392 16.52 1.448 16.88 1.56 17.232C1.672 17.584 1.896 17.76 2.232 17.76C2.728 17.76 3.28 17.336 3.888 16.488C4.496 15.624 5.144 14.52 5.832 13.176C5.96 12.504 6.064 12.024 6.144 11.736C6.24 11.432 6.328 11.24 6.408 11.16C6.504 11.064 6.632 11.016 6.792 11.016C7 11.016 7.168 11.064 7.296 11.16C7.424 11.24 7.488 11.368 7.488 11.544C7.488 11.592 7.472 11.68 7.44 11.808C7.264 12.4 7.104 13.184 6.96 14.16C6.832 15.136 6.768 16.024 6.768 16.824C6.768 17.608 6.944 18 7.296 18C7.744 18 8.328 17.504 9.048 16.512C9.768 15.504 10.424 14.36 11.016 13.08C11.016 11.048 11.416 10.032 12.216 10.032C12.488 10.032 12.696 10.136 12.84 10.344C13 10.536 13.08 10.736 13.08 10.944C13.08 11.104 13 11.328 12.84 11.616C12.648 11.984 12.496 12.352 12.384 12.72C12.288 13.072 12.24 13.552 12.24 14.16C12.24 14.688 12.312 15.128 12.456 15.48C12.616 15.816 12.92 15.984 13.368 15.984C13.72 15.984 14.048 15.848 14.352 15.576C14.656 15.304 14.96 14.848 15.264 14.208L15.576 14.448C15 15.792 14.208 16.464 13.2 16.464C12.704 16.464 12.28 16.296 11.928 15.96C11.592 15.624 11.344 15.12 11.184 14.448C10.512 15.696 9.776 16.76 8.976 17.64C8.192 18.504 7.456 18.936 6.768 18.936ZM17.4045 19.056C16.4605 19.056 15.7325 18.792 15.2205 18.264C14.7245 17.752 14.4765 17.088 14.4765 16.272C14.4765 15.328 14.7885 14.312 15.4125 13.224C16.0365 12.136 16.8205 11.224 17.7645 10.488C18.7245 9.736 19.6605 9.36 20.5725 9.36C21.5645 9.36 22.0605 9.848 22.0605 10.824C22.0605 11.608 21.7645 12.344 21.1725 13.032C20.5805 13.704 19.8205 14.256 18.8925 14.688C17.9645 15.12 17.0365 15.384 16.1085 15.48C16.0445 15.752 16.0125 16.04 16.0125 16.344C16.0125 16.92 16.1565 17.4 16.4445 17.784C16.7325 18.168 17.2205 18.36 17.9085 18.36C18.8845 18.36 19.8685 17.952 20.8605 17.136C21.8525 16.32 22.6605 15.312 23.2845 14.112L23.5725 14.328C22.9325 15.752 22.0445 16.896 20.9085 17.76C19.7725 18.624 18.6045 19.056 17.4045 19.056ZM16.2285 15.024C16.9005 14.784 17.6045 14.448 18.3405 14.016C19.0765 13.584 19.7005 13.08 20.2125 12.504C20.7405 11.912 21.0045 11.296 21.0045 10.656C21.0045 10.464 20.9645 10.328 20.8845 10.248C20.8205 10.152 20.6925 10.104 20.5005 10.104C20.0045 10.104 19.4605 10.352 18.8685 10.848C18.2925 11.344 17.7565 11.976 17.2605 12.744C16.7805 13.512 16.4365 14.272 16.2285 15.024ZM24.7967 18.72C24.1407 18.72 23.6527 18.496 23.3327 18.048C23.0287 17.6 22.8767 17 22.8767 16.248C22.8767 14.808 23.3727 12.856 24.3647 10.392C25.3567 7.912 26.4607 5.68 27.6767 3.696C28.9087 1.712 29.7967 0.719999 30.3407 0.719999C30.5647 0.719999 30.7487 0.919999 30.8927 1.32C31.0527 1.704 31.1327 2.096 31.1327 2.496C31.1327 3.232 30.8287 4.32 30.2207 5.76C29.6287 7.184 28.8447 8.632 27.8687 10.104C26.8927 11.576 25.8527 12.768 24.7487 13.68C24.5407 14.608 24.4367 15.416 24.4367 16.104C24.4367 17.336 24.7887 17.952 25.4927 17.952C26.0847 17.952 26.6847 17.576 27.2927 16.824C27.9167 16.072 28.4687 15.168 28.9487 14.112L29.3087 14.304C27.9327 17.248 26.4287 18.72 24.7967 18.72ZM24.9647 12.864C25.8447 11.984 26.7007 10.88 27.5327 9.552C28.3807 8.208 29.0687 6.928 29.5967 5.712C30.1247 4.48 30.3887 3.592 30.3887 3.048C30.3887 2.792 30.3327 2.664 30.2207 2.664C29.9967 2.664 29.5327 3.216 28.8287 4.32C28.1407 5.408 27.4287 6.744 26.6927 8.328C25.9567 9.912 25.3807 11.424 24.9647 12.864ZM31.0446 19.344C30.2446 19.344 29.5966 19.08 29.1006 18.552C28.6046 18.024 28.3566 17.264 28.3566 16.272C28.3566 15.232 28.6206 14.216 29.1486 13.224C29.6766 12.232 30.3486 11.432 31.1646 10.824C31.9966 10.2 32.8126 9.888 33.6126 9.888C34.2206 9.888 34.6526 10.064 34.9086 10.416C35.1806 10.752 35.3166 11.168 35.3166 11.664C35.3166 12.144 35.2046 12.56 34.9806 12.912C34.7726 13.248 34.4846 13.416 34.1166 13.416C33.8446 13.416 33.6126 13.296 33.4206 13.056C33.6606 12.944 33.8686 12.696 34.0446 12.312C34.2206 11.912 34.3086 11.528 34.3086 11.16C34.3086 10.952 34.2686 10.8 34.1886 10.704C34.1086 10.608 33.9726 10.56 33.7806 10.56C33.2366 10.56 32.6526 10.888 32.0286 11.544C31.4206 12.184 30.9006 12.968 30.4686 13.896C30.0526 14.824 29.8446 15.672 29.8446 16.44C29.8446 17.016 29.9806 17.496 30.2526 17.88C30.5246 18.248 30.9726 18.432 31.5966 18.432C32.5726 18.432 33.5326 18.032 34.4766 17.232C35.4366 16.432 36.1726 15.384 36.6846 14.088L36.9966 14.328C36.6286 15.288 36.1246 16.152 35.4846 16.92C34.8446 17.672 34.1326 18.264 33.3486 18.696C32.5806 19.128 31.8126 19.344 31.0446 19.344ZM37.8904 18.768C37.2344 18.768 36.7544 18.568 36.4504 18.168C36.1464 17.768 35.9944 17.24 35.9944 16.584C35.9944 15.928 36.1304 15.24 36.4024 14.52C36.6744 13.8 37.0264 13.2 37.4584 12.72C37.8904 12.24 38.3224 12 38.7544 12C38.8984 12 39.0664 12.04 39.2584 12.12C39.0664 12.28 38.8344 12.632 38.5624 13.176C38.2904 13.72 38.0504 14.304 37.8424 14.928C37.6504 15.536 37.5544 16.032 37.5544 16.416C37.5544 17.328 37.8424 17.784 38.4184 17.784C38.7544 17.784 39.1544 17.608 39.6184 17.256C40.0824 16.904 40.5384 16.44 40.9864 15.864C40.5384 15.496 40.1864 15.016 39.9304 14.424C39.6904 13.832 39.5704 13.216 39.5704 12.576C39.5704 11.744 39.7784 11.032 40.1944 10.44C40.6264 9.848 41.2024 9.552 41.9224 9.552C42.5304 9.552 42.9544 9.72 43.1944 10.056C43.4504 10.376 43.5784 10.824 43.5784 11.4C43.5784 12.008 43.4264 12.696 43.1224 13.464C42.8344 14.216 42.4504 14.952 41.9704 15.672C42.2584 15.832 42.5624 15.912 42.8824 15.912C43.3464 15.912 43.8264 15.776 44.3224 15.504C44.8184 15.216 45.1944 14.776 45.4504 14.184L45.7384 14.424C45.4344 15.128 45.0024 15.648 44.4424 15.984C43.8824 16.32 43.3064 16.488 42.7144 16.488C42.2824 16.488 41.8984 16.408 41.5624 16.248C40.9864 17 40.3704 17.608 39.7144 18.072C39.0744 18.536 38.4664 18.768 37.8904 18.768ZM41.4184 15.24C41.8344 14.616 42.1704 13.984 42.4264 13.344C42.6824 12.688 42.8104 12.088 42.8104 11.544C42.8104 11.096 42.7384 10.76 42.5944 10.536C42.4664 10.312 42.2984 10.2 42.0904 10.2C41.8664 10.2 41.6344 10.312 41.3944 10.536C41.1704 10.744 40.9784 11.04 40.8184 11.424C40.6744 11.792 40.6024 12.2 40.6024 12.648C40.6024 13.144 40.6664 13.624 40.7944 14.088C40.9384 14.536 41.1464 14.92 41.4184 15.24ZM57.096 18.744C56.568 18.744 56.168 18.576 55.896 18.24C55.624 17.92 55.488 17.504 55.488 16.992C55.488 16.56 55.616 15.928 55.872 15.096C55.952 14.824 56.024 14.552 56.088 14.28C56.168 14.008 56.208 13.776 56.208 13.584C56.208 13.296 56.136 13.08 55.992 12.936C55.864 12.792 55.704 12.72 55.512 12.72C55.144 12.72 54.744 12.984 54.312 13.512C53.896 14.024 53.248 14.952 52.368 16.296C52.144 16.648 51.832 17.24 51.432 18.072L51.216 18.528C50.96 18.528 50.688 18.48 50.4 18.384C50.128 18.304 49.992 18.192 49.992 18.048C49.992 17.936 50.128 17.512 50.4 16.776C50.736 15.784 51 14.952 51.192 14.28C51.4 13.592 51.504 13.008 51.504 12.528C51.504 11.92 51.304 11.616 50.904 11.616C50.456 11.616 49.872 11.976 49.152 12.696C48.448 13.416 47.752 14.328 47.064 15.432C46.376 16.52 45.84 17.592 45.456 18.648C45.216 18.648 44.944 18.592 44.64 18.48C44.32 18.368 44.16 18.256 44.16 18.144C44.16 18.096 44.272 17.72 44.496 17.016C44.864 15.944 45.168 14.96 45.408 14.064C45.664 13.168 45.8 12.392 45.816 11.736C45.928 11.608 46.088 11.496 46.296 11.4C46.504 11.288 46.712 11.232 46.92 11.232C47.352 11.232 47.568 11.44 47.568 11.856C47.568 12.288 47.36 13.2 46.944 14.592C47.728 13.344 48.568 12.272 49.464 11.376C50.376 10.48 51.224 10.032 52.008 10.032C52.472 10.032 52.8 10.2 52.992 10.536C53.2 10.872 53.304 11.312 53.304 11.856C53.304 12.4 53.224 12.992 53.064 13.632C52.904 14.272 52.736 14.808 52.56 15.24C53.168 14.136 53.8 13.248 54.456 12.576C55.112 11.888 55.808 11.544 56.544 11.544C57.024 11.544 57.368 11.688 57.576 11.976C57.8 12.264 57.912 12.632 57.912 13.08C57.912 13.384 57.872 13.712 57.792 14.064C57.712 14.4 57.592 14.816 57.432 15.312C57.16 16.16 57.024 16.752 57.024 17.088C57.024 17.632 57.264 17.904 57.744 17.904C58.336 17.904 58.896 17.544 59.424 16.824C59.952 16.088 60.464 15.184 60.96 14.112L61.248 14.448C60.8 15.632 60.216 16.648 59.496 17.496C58.776 18.328 57.976 18.744 57.096 18.744ZM63.1076 19.056C62.1636 19.056 61.4356 18.792 60.9236 18.264C60.4276 17.752 60.1796 17.088 60.1796 16.272C60.1796 15.328 60.4916 14.312 61.1156 13.224C61.7396 12.136 62.5236 11.224 63.4676 10.488C64.4276 9.736 65.3636 9.36 66.2756 9.36C67.2676 9.36 67.7636 9.848 67.7636 10.824C67.7636 11.608 67.4676 12.344 66.8756 13.032C66.2836 13.704 65.5236 14.256 64.5956 14.688C63.6676 15.12 62.7396 15.384 61.8116 15.48C61.7476 15.752 61.7156 16.04 61.7156 16.344C61.7156 16.92 61.8596 17.4 62.1476 17.784C62.4356 18.168 62.9236 18.36 63.6116 18.36C64.5876 18.36 65.5716 17.952 66.5636 17.136C67.5556 16.32 68.3636 15.312 68.9876 14.112L69.2756 14.328C68.6356 15.752 67.7476 16.896 66.6116 17.76C65.4756 18.624 64.3076 19.056 63.1076 19.056ZM61.9316 15.024C62.6036 14.784 63.3076 14.448 64.0436 14.016C64.7796 13.584 65.4036 13.08 65.9156 12.504C66.4436 11.912 66.7076 11.296 66.7076 10.656C66.7076 10.464 66.6676 10.328 66.5876 10.248C66.5236 10.152 66.3956 10.104 66.2036 10.104C65.7076 10.104 65.1636 10.352 64.5716 10.848C63.9956 11.344 63.4596 11.976 62.9636 12.744C62.4836 13.512 62.1396 14.272 61.9316 15.024Z"
            fill="white"
            strokeWidth="0.5"
            className={classes.svgAnimation}
          />
        </svg> */}
        {/* <div className={classes.selfOrderText}>
                    Self-ordering
                </div> */}
      </div>
      <div className={classes.footer}>
        <span className={classes.text}>Powered by</span>
        <img className={classes.auposLogo} src={auposLogo} alt="" />
      </div>
      {expired && expired.timeLimit && (
        <div className={classes.clock}>
          <MealClock />
        </div>
      )}
    </Cover>
  );
};

export default WelcomeModal;

const useStyles = createUseStyles((theme: any) => {
  return {
    selfOrderText: {
      fontFamily: "PingFang",
      color: "#191919",
      fontSize: "12px",
      textTransform: "uppercase",
      lineHeight: "17px",
      letterSpacing: "1px",
      transform: "translateY(10px)",
      animation: "$fadein 5s linear",
    },
    shopBanner: {
      maxWidth: "300px",
      maxHeight: "86px",
      // marginBottom: '26px',
      position: "absolute",
      opacity: 1,
      animation: "$fadein 5s linear",
    },
    bannerContainer: {
      height: "86px",
      marginTop: "8px",
      marginBottom: "26px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    "@keyframes fadein": {
      "0%": { opacity: 0 },
      "50%": { opacity: 0.2 },
      "60%": { opacity: 0.4 },
      "90%": { opacity: 0.7 },
      "100%": { opacity: 1 },
    },
    svgAnimation: {
      // strokeWidth: "1",
      stroke: "#887650",
      strokeDasharray: 467,
      strokeDashoffset: 467,
      animation: "$svgDraw 5s linear",
      opacity: 0,
      marginBottom: "36px",
    },

    "@keyframes svgDraw": {
      "0%": { strokeDashoffset: 467, opacity: 1 },
      "80%": { strokeDashoffset: 0, opacity: 0.5 },
      "100%": { strokeDashoffset: 0, opacity: 0 },
    },
    closeButton: {
      position: "absolute",
      top: "5px",
      right: "5px",
      height: "24px",
      width: "24px",
    },
    img: {
      width: "100%",
      marginBottom: "50px",
    },
    clock: {
      width: "35px",
      height: "39px",
      position: "absolute",
      bottom: "14px",
      right: "25px",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      justifyContent: "center",
    },
    text: {
      color: "#6D7278",
      fontSize: "10px",
      lineHeight: "12px",
      fontFamily: "Helvetica",
      marginRight: "5px",
      whiteSpace: "nowrap",
    },
    auposLogo: {
      height: "12px",
      marginBottom: "1px",
    },
    noticeContainer: {
      flex: 1,
      display: "flex",
      width: "100%",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "flex-start",
      color: "#888",
    },
    enNotice: { fontSize: "10px" },
    cnNotice: {
      fontSize: "12px",
    },
    limitValue: {
      width: "100%",
      textAlign: "center",
      color: theme.colors.main,
      fontSize: "22px",
    },
  };
});
